import {
  Box,
  Container,
  Divider,
  Heading,
  Image,
  Spinner,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";

export default function BlogScreen({ blog, setBlog, loading, setLoading }) {
  if (loading) {
    return (
      <Box textAlign="center" mt={10}>
        <Spinner size="xl" />
      </Box>
    );
  }

  if (!blog) {
    return (
      <Box textAlign="center" mt={10}>
        <Text color="red.500">Blog not found.</Text>
      </Box>
    );
  }

  return (
    <Container maxW="6xl" px={[4, 6, 8]} py={24}>
      {/* Blog Title */}
      <Heading
        as="h1"
        fontSize={["2xl", "3xl", "4xl"]}
        mb={6}
        textAlign="center"
      >
        {blog.title}
      </Heading>
      {/* Banner Image Grid */}
      {Array.isArray(blog.bannerImage) && blog.bannerImage.length > 0 && (
        <Image
          src={blog.bannerImage[0]}
          alt={`Banner ${blog?.slug}`}
          borderRadius="xl"
          objectFit="cover"
          w="100%"
          h={{ base: "30vh", sm: "40vh", md: "60vh", lg: "70vh" }} // Responsive heights
          shadow="md"
          _hover={{ transform: "scale(1.02)", transition: "0.3s" }}
        />
      )}

      {/* Blog Sections */}
      <VStack py={4} spacing={10} align="stretch">
        {blog.contentSections?.map((section, idx) => (
          <Box key={idx}>
            {section.heading && (
              <Heading
                as="h2"
                fontSize={["lg", "xl", "2xl"]}
                mb={1}
                color="teal.600"
              >
                {section.heading}
              </Heading>
            )}
            {section.description && (
              <Box
                fontSize={["sm", "md", "lg"]}
                color="gray.700"
                lineHeight="taller"
                dangerouslySetInnerHTML={{ __html: section.description }}
              />
            )}

            {blog.bannerImage?.[idx + 1] && (
              <Image
                src={blog.bannerImage[idx + 1]}
                alt={`Section Image ${idx + 1}`}
                borderRadius="xl"
                objectFit="cover"
                w="100%"
                height={"70vh"}
                mt={6}
                shadow="md"
                _hover={{ transform: "scale(1.01)", transition: "0.3s" }}
              />
            )}
            {idx !== blog.contentSections.length - 1 && <Divider mt={8} />}
          </Box>
        ))}
      </VStack>
    </Container>
  );
}
